import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { IoIosArrowDown } from "react-icons/io";
import { FaCog, FaEdit, FaTrashAlt } from "react-icons/fa";

function CategoryDiscount() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState([]);

  const columns = [
    {
      header: "SN",
      cell: (sn) => sn.row.index + 1,
    },
    {
      header: "Product Name",
      // accessorKey: "ProductName",
      cell: (product) => (product.row.original.category[0]?.category_name),
    },
    {
      header: "Start Date",
      accessorKey: "start_date",
    },
    {
      header: "End Date",
      accessorKey: "end_date",
    },
    {
      header: "Amount",
      accessorKey: "discount_amount",
    },
    {
      header: "Discount Type",
      accessorKey: "dis_type",
      cell: (row) =>
        row.getValue() === "percentage"
          ? "Percentage"
          : row.getValue() === "amount"
          ? "Amount"
          : "",
    },
    {
      header: "Use Discount",
      accessorKey: "use_discount",
      cell: (row) =>
        row.getValue() === "one_time"
          ? "One Time"
          : row.getValue() === "regular"
          ? "Regular"
          : "",
    },
    {
      header: "Actions",
      cell: (row) => (
        <ActionDropdown
          id={row.row.original.id}
          user={user}
          refetchData={fetchCategoryDiscount}
        />
      ),
    },
  ];

  const buttonData = [
    {
      buttonText: "Add Category Discount",
      path: "AddCategoryDiscountForm",
    },
  ];

  const fetchCategoryDiscount = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/discounts`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          includes: "category",
          outletId: user?.user.outlet_id
        },
      })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    setPageLoading(true);

    handleCSRF(fetchCategoryDiscount);
  }, [fetchCategoryDiscount]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        error={error}
        heading={"Category Discount"}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
    </main>
  );
}

function ActionDropdown({ id, user, refetchData }) {
  const [showDropdown, setShowDropDown] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const handleDelete = () => {
    axios
      .delete(`${apiKey}/api/rms/admin/discounts/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.data, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        refetchData();
        setShowDelModal(false);
        setShowDropDown(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  return (
    <>
      <div className="relative">
        <button
          className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
          onClick={() => setShowDropDown(!showDropdown)}
        >
          <FaCog className="text-[#774d96]" />
          <IoIosArrowDown className="text-[#774d96]" />
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-10 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
          }
        >
          <Link
            to={`AddCategoryDiscountForm/${id}`}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaEdit />
            <p> Edit </p>
          </Link>
          <button
            onClick={() => setShowDelModal(true)}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaTrashAlt />
            <p> Delete </p>
          </button>
        </div>
      </div>

      {showDelModal && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
          onClick={() => setShowDelModal(false)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-[#774d96] font-semibold text-xl text-center">
                Alert!
              </h1>
              <p className="text-center text-gray-700">Are you sure?</p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-[#7B20C7] text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setShowDelModal(false)}
              >
                No
              </button>
              <button
                onClick={handleDelete}
                className="bg-[#7B20C7] text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CategoryDiscount;
